export default "__VITE_ASSET__DchLF$lH__"